import { FormField, FormSection } from '@hilma/netina2all';

import { I18n } from '../types';

export const generalAssociationDetails: FormField<I18n>[] = [
	{
		description: i18n => i18n.am.name,
		id: 'associationName',
		required: true
	},
	{
		description: i18n => i18n.am.email,
		id: 'email',
		ltr: true,
		required: true
	},
	{
		description: i18n => i18n.am.phone,
		id: 'phone',
		ltr: true,
		required: true,
		readonly: true
	}
];

export const filesAndGeneralDetails: FormField<I18n>[] = [
	{
		description: i18n => i18n.am.contactPerson,
		id: 'contact',
		required: true
	},
	{
		description: i18n => i18n.am.signedContract,
		id: 'signedContract',
		inputType: 'file',
		tooltip: 'אישור חוזה חתום',
		download: {
			fieldNames: ['signedContract']
		},
		required: true
	},
	{
		description: i18n => i18n.am.acceptedProcedure,
		id: 'properManagement',
		inputType: 'file',
		tooltip: 'אישור ניהול תקין',
		required: true
	},
	{
		description: i18n => i18n.am.section46,
		id: 'section46',
		inputType: 'file',
		tooltip: 'סעיף 46',
		required: true
	},
	{
		description: i18n => i18n.am.section46Exp,
		id: 'section46Expiry',
		inputType: 'date',
		required: true
	},
];


export const bankDetailsInfo: FormSection<I18n> = {
	title: i18n => i18n.am.bankInfo.title,
	data: [
		{
			description: i18n => i18n.am.bankInfo.accountHolder,
			id: 'bankAccountHolder',
			descriptionQuestion: true,
			required: true
		},
		{
			description: i18n => i18n.am.bankInfo.bank,
			id: 'bankName',
			inputType: 'select',
			required: true
		},
		{
			description: i18n => i18n.am.bankInfo.branch,
			id: 'bankBranchNumber',
			required: true
		},
		{
			description: i18n => i18n.am.bankInfo.bankAccountNumber,
			id: 'bankAccountNumber',
			required: true
		}
	],
};

export const additionalDetailsInfo: FormSection<I18n> = {
	title: i18n => i18n.am.additionalDetails,
	data: [
		{
			description: i18n => i18n.am.numVol,
			id: 'volunteerNumber',
		},
		{
			description: i18n => i18n.am.url,
			id: 'website',
			ltr: true,
			required: true
		},
		{
			description: i18n => i18n.am.goalKitsLong,
			id: 'goalKits',
		}
	]
};